import React, { useEffect, useState } from 'react';
import Button from '../../../../components/inputs/yup/materialui/mButton';
import ChecklistTwoToneIcon from '@mui/icons-material/ChecklistTwoTone';
import RecommendTwoToneIcon from '@mui/icons-material/RecommendTwoTone';
import Grid2 from "@mui/material/Grid2";
import { ValidacionMutuoResult } from '../../models/ValidacionMutuoResult';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardValidaciones from './cardValidaciones';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { AprobacionMutuoResult } from '../../models/AprobacionMutuoResult';
import { useToast } from '../../../../hooks/useToast';
import { Mutuo, useMutuo } from '../../hooks/useMutuo';
import { EnumEstadoMutuo, StatusCode, TipoFuncionalidad } from '../../../../utils/enums';
import BlockIcon from '@mui/icons-material/Block';
import { desactivar } from '../../services/serviceDesactivarMutuo';
import { UseBandejaMutuos } from '../../../bandejaMutuos/hooks/useBandejaMutuos';
import { DetalleMutuoPermissionGuard } from '../../../../components/auth/DetalleMutuoPermissionGuard';

interface IProps {
    mutuoId: number;
    filtros: any;
    onDesactivarClick: () => void;
    isDesactivado?: boolean;
    esVigente: boolean;
}


export enum StatusResult {
    Exito = "Success",
    Fallo = "Fail"
}

const ValidacionesForm: React.FC<IProps> = (props) => {

    const [validaciones, setValidaciones] = useState<ValidacionMutuoResult>();
    const { validarMutuo, aprobarMutuo, obtenerMutuo } = useMutuo();
    //Estados
    const [isMutuoAprobado, setIsMutuoAprobado] = useState<boolean>(false);
    const [isMutuoActivado, setIsMutuoActivado] = useState<boolean>(false);

    const [mutuo, setMutuo] = useState<Mutuo | void>();
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => { },
    });
    const { addToast } = useToast();
    const { activarMutuoIndividual } = UseBandejaMutuos();

    useEffect(() => {
        isActivado();
        handleValidarMutuo();
    }, [props.mutuoId]);

    useEffect(() => {
        const fetchMutuo = async () => {
            const dataMutuo: Mutuo | void = await obtenerMutuo(props.mutuoId);
            setMutuo(dataMutuo);
            const isAprobado: boolean = !dataMutuo || dataMutuo.estadoActual === EnumEstadoMutuo.Ingresado;
            setIsMutuoAprobado(isAprobado);
        };
        fetchMutuo();
    }, [props.mutuoId]);

    async function handleValidarMutuo() {
        const validacionResult: ValidacionMutuoResult | void = await validarMutuo(props.mutuoId);
        if (!validacionResult) return;
        setValidaciones(validacionResult);
    }

    const handleAprobarButtonlick = () => {
        const warnings = validaciones?.businessRulesResults.filter(w => w.messageType === 'Warning' && w.aplicaRegla);

        setModalConfirmacion({
            show: true,
            title: "Aprobar operación",
            message: (warnings && warnings!.length > 0)
                ? `Existen advertencias en la sección ${warnings![0].group.toLowerCase()}. ¿Desea continuar con la aprobación?`
                : "¿Confirma la aprobación de la operación?",
            metodo: async () => {
                const aprobacionResult: AprobacionMutuoResult | void = await aprobarMutuo(props.mutuoId);
                if (aprobacionResult) {
                    const { status, data, message } = aprobacionResult;
                    const isExito = status === StatusResult.Exito;
                    setIsMutuoAprobado(isExito);
                    setValidaciones(data);

                    addToast({
                        mostrar: true,
                        titulo: isExito ? 'Operación exitosa' : 'Operación fallida',
                        tipo: isExito ? 'Success' : 'Danger',
                        mensaje: isExito
                            ? 'Operación aprobada correctamente'
                            : `No fué posible aprobar la operación (${message}).`,
                    });
                }
            },
        });
    }



    const handleDesactivar = () => {
        props.onDesactivarClick();
    }


    const isActivado = async () => {
        const resp = await desactivar(props.mutuoId);
        if (resp.status === StatusCode.Ok) {
            const estadoMutuo = resp.data.estado;
            if (estadoMutuo === EnumEstadoMutuo.Activado) {
                setIsMutuoActivado(true);
            }
        }
    }

    const handleActivarMutuo = async (ignorePrecioVenta: boolean) => {
        const resp = await activarMutuoIndividual(props.mutuoId, ignorePrecioVenta);
        if (resp.status === StatusCode.Ok) {
            addToast({
                mostrar: true,
                titulo: 'Mutuo activado exitosamente',
                tipo: 'Success',
                mensaje: "Mutuo activado exitosamente",
            });
            setIsMutuoActivado(true);
        }
        else if (!ignorePrecioVenta) {
            if (resp.response.status === 400 && resp.response.data.message === "La suma de la garantía es menor al precio de venta del mutuo") {
                setModalConfirmacion({
                    show: true,
                    title: "Confirmar activación",
                    message: "La suma de la garantía es menor al precio de venta del mutuo ¿Confirma la activación de la operación?",
                    metodo: () => { handleActivarMutuo(true) }
                })
            }
            else {
                addToast({
                    mostrar: true,
                    titulo: 'Operación fallida',
                    tipo: 'Danger',
                    mensaje: resp.response.data.message,
                });
            }
        }
        else {
            addToast({
                mostrar: true,
                titulo: 'Operación fallida',
                tipo: 'Danger',
                mensaje: resp.response.data.message,
            });
        }
    }

    const handleConfirmarActivarMutuo = () => {
        setModalConfirmacion({
            show: true,
            title: "Confirmar activación",
            message: "¿Confirma la activación de la operación?",
            metodo: () => { handleActivarMutuo(false) }
        })
    }

    return (
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />

            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, lg: 2 }}>
                    <h3></h3>
                </Grid2>

                <Grid2 size={{ xs: 12, lg: 10 }} container justifyContent="flex-end" spacing={1}>
                    <DetalleMutuoPermissionGuard
                        esVigente={props.esVigente}
                        permissions={[TipoFuncionalidad.Bandeja_ver]}>
                        <Grid2>
                            <Button
                                variant="contained"
                                onClick={handleValidarMutuo}
                                startIcon={<ChecklistTwoToneIcon />}
                                //Habilitar en Ingresado y Aprobado => No activado
                                disabled={isMutuoActivado || props.isDesactivado}
                            >
                                Validar
                            </Button>
                        </Grid2>
                    </DetalleMutuoPermissionGuard>
                    <DetalleMutuoPermissionGuard
                        esVigente={props.esVigente}
                        permissions={[TipoFuncionalidad.Bandeja_aprobar]}>
                        <Grid2>
                            <Button
                                variant="contained"
                                startIcon={<RecommendTwoToneIcon />}
                                onClick={handleAprobarButtonlick}
                                disabled={!validaciones || validaciones.status === StatusResult.Fallo || isMutuoAprobado || isMutuoActivado || props.isDesactivado}
                            //Habilitar en Ingresado
                            >
                                Aprobar
                            </Button>
                        </Grid2>
                    </DetalleMutuoPermissionGuard>
                    <DetalleMutuoPermissionGuard
                        esVigente={props.esVigente}
                        permissions={[TipoFuncionalidad.Activar_mutuo]}>
                        <Grid2>
                            <Button
                                variant="contained"
                                startIcon={<CheckCircleOutlineIcon />}
                                onClick={handleConfirmarActivarMutuo}
                                //Habilitar en Aprobado
                                disabled={isMutuoActivado || !isMutuoAprobado || props.isDesactivado}
                            >
                                Activar
                            </Button>
                        </Grid2>
                    </DetalleMutuoPermissionGuard>
                    <DetalleMutuoPermissionGuard
                        esVigente={props.esVigente}
                        permissions={[TipoFuncionalidad.Desactivar_mutuo]}>
                        <Grid2>
                            <Button
                                variant="contained"
                                startIcon={<BlockIcon />}
                                onClick={handleDesactivar}
                                //Habilitar en Activado
                                disabled={!isMutuoActivado || props.isDesactivado}
                            >
                                Desactivar
                            </Button>
                        </Grid2>
                    </DetalleMutuoPermissionGuard>
                </Grid2>
            </Grid2 >

            <hr className="form-hr border-3 opacity-75" />

            <Grid2 container spacing={2} mt={2}>
                <Grid2 size={{ xs: 12 }}>
                    {validaciones && <CardValidaciones validaciones={validaciones}
                        titulo="Sección responsables"
                        grupoComparacion="Responsables" />}

                    {validaciones && <CardValidaciones validaciones={validaciones}
                        titulo="Sección participantes"
                        grupoComparacion="Participantes" />}

                    {validaciones && <CardValidaciones validaciones={validaciones!}
                        titulo="Sección operación"
                        grupoComparacion="Operacion" />}

                    {validaciones && <CardValidaciones validaciones={validaciones!}
                        titulo="Sección garantía"
                        grupoComparacion="Garantia" />}
                </Grid2>
            </Grid2>
        </>
    );
};

export default ValidacionesForm;